import { request } from "../../Services/Api"

export const getAdminInvoices = (params) => request.api.get(`/payments/invoices/`, params)
export const getAdminInvoicesFilterOptions = () =>
  request.api.get("/payments/invoices/filter_options/")
export const getAdminInvoicesExport = ({ file_name, ...params }) =>
  request.api.get(`/payments/invoices/export_data/`, params)
export const updateAdminInvoice = ({ id, ...data }) =>
  request.api.patch(`/payments/invoices/${id}/update_status/`, data)
export const confirmInvoice = ({ id, ...data }) =>
  request.api.post(`/payments/invoices/${id}/confirm/`, data)
export const changeInvoiceAmount = ({ id, ...data }) =>
  request.api.post(`/payments/invoices/${id}/change_amount/`, data)
